import 'css-chunksrc/client/common/filterMenu/projectsElementsTags/styles.scss';export default {
  "header": "_header_cf9yc_1",
  "icon": "_icon_cf9yc_10",
  "title": "_title_cf9yc_18",
  "list": "_list_cf9yc_25"
};